export default __webpack_public_path__ + "static/media/Google-Classroom.fe337d64.svg";